import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import FixedHeader from 'App/components/FixedHeader'
import Field from './Field'
import {DragDropContext} from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import Page from './Page'
import cloneDeep from 'lodash/cloneDeep'
import autobind from 'autobind-decorator'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import fragment from './fragment'
import omit from 'lodash/omit'
import Button from 'orionsoft-parts/lib/components/Button'
import {withRouter} from 'react-router'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import OkIcon from 'react-icons/lib/md/check-circle'
import NotOkIcon from 'react-icons/lib/md/error-outline'
import MdInfoOutline from 'react-icons/lib/md/info-outline'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import withOrganization from 'App/Decorators/withOrganization'

@withMessage
@withGraphQL(gql`
  query getDocument($documentId: ID) {
    document(documentId: $documentId) {
      organizationAdmin
      ...documentPrepareFragment
    }
  }
  ${fragment}
`)
@withMutation(gql`
  mutation setDocumentFields($documentId: ID!, $fields: [DocumentFieldInput], $organizationId: ID) {
    setDocumentFields(documentId: $documentId, fields: $fields, organizationId: $organizationId) {
      ...documentPrepareFragment
    }
  }
  ${fragment}
`)

@withOrganization
@withRouter
@DragDropContext(HTML5Backend)
export default class Prepare extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    router: PropTypes.object,
    document: PropTypes.object,
    setDocumentFields: PropTypes.func,
    organization: PropTypes.object
  }

  updateNumeroFirmasOcupadas() {
    let fields = this.props.document.fields
    let numFirmas = 0

    if (fields && fields.length > 0) {
      fields.forEach(field => {
        if (field.type === 'signature') { numFirmas++ }
      })
      console.log('Hay ' + numFirmas + ' ')
      return numFirmas
    }
    return 0
  }

  renderFirmasDisponibles() {
    let firmasUsadas = this.updateNumeroFirmasOcupadas()
    let numeroFirmasUsadas = Math.max(1, firmasUsadas)
    let numeroFirmasAvanzadas = this.props.document.feaSigners ? this.props.document.feaSigners.length : 0
    // let numeroFirmasFaciales = this.props.document.faceSigners ? this.props.document.faceSigners.length : 0

    return (
      <div>
        <h3>Firmas simples a ocupar: {numeroFirmasUsadas}</h3>
        <h3>Firmas avanzadas a ocupar: {numeroFirmasAvanzadas}</h3>
        {this.renderInfoAvanzadas(numeroFirmasAvanzadas)}
      </div>
    )
  }

// <h3>Firmas faciales a ocupar: {numeroFirmasFaciales}</h3>

  renderInfoAvanzadas(numeroAvanzadas) {
    if (numeroAvanzadas > 0) {
      return (
        <p>Las firmas electrónicas avanzadas no requieren ser agregadas en esta etapa</p>
      )
    }
  }

  state = {
    fields: [],
    openedFieldMenu: null,
    numAvanzadas: 0
  }

  async update(fields) {

    try {
      const optimisticResponse = {
        __typename: 'Mutation',
        setDocumentFields: {
          __typename: 'Document',
          ...this.props.document,
          fields: fields
            .map(field => ({
              ...field,
              __typename: 'DocumentField'
            }))
            .map(field => {
              if (field.value) {
                field.value = {
                  ...field.value,
                  __typename: 'FieldValue'
                }
              }
              return field
            })
        }
      }

      await this.props.setDocumentFields(
        {
          documentId: this.props.document._id,
          fields,
          organizationId: this.props.organization._id
        },
        {
          refetchQueries: ['getDocument', 'document']
        },
        {optimisticResponse}
      )
      // this.updateNumeroFirmasOcupadas(fields)

    } catch (error) {
      this.props.showMessage(error.message, {level: 'error'})
      console.log(error)
    }
  }

  @autobind
  addField(data) {
    const fields = cloneDeep(this.props.document.fields || [])
    const id = Math.random()
      .toString(36)
      .substr(2, 10)
    fields.push({
      id,
      ...data
    })
    this.update(fields)
    return id
  }

  @autobind
  updateField(id, data) {
    if (!data.filler && data.validation) {
      data.validation = null
    }
    var fields = cloneDeep(this.props.document.fields || [])
    for (let i = 0; i < fields.length; i++) {
      if (fields[i].id === id) {
        fields.splice(i, 1)
      }
    }
    if (data.value) {
      data.value = omit(data.value, '__typename', 'Symbol(id)')
    }
    if (data.textSize) {

    }
    console.log('Pusheando ', data)
    fields.push({id, ...data})
    this.update(fields)
  }

  @autobind
  deleteField(id) {
    const fields = cloneDeep(this.props.document.fields || [])
    for (let i = 0; i < fields.length; i++) {
      if (fields[i].id === id) {
        fields.splice(i, 1)
      }
    }
    this.update(fields)
  }

  renderPages() {
    if (!this.props.document) return
    return this.props.document.pages.map(page => {
      const fieldsInPage = (this.props.document.fields || []).filter(
        field => field.page === page.index
      )
      return (
        <Page
          document={this.props.document}
          addField={this.addField}
          updateField={this.updateField}
          deleteField={this.deleteField}
          page={page}
          key={page.index}
          fields={fieldsInPage}
          openFieldMenu={openedFieldMenu => this.setState({openedFieldMenu})}
          openedFieldMenu={this.state.openedFieldMenu}
        />
      )
    })
  }

  renderButtons() {

    return (
      <div className="row">
        <div className="col-xs-12 center-xs col-sm-3">
          <span className={styles.fieldsAssigned}>
            <Tooltip
              content={
                this.props.document && this.props.document.fieldsAssigned
                  ? 'Todo se ve bien'
                  : 'Hay campos que no estan asignados o firmantes sin campos asignados'
              }
            >
              {this.props.document && this.props.document.fieldsAssigned ? (
                <OkIcon size={20} />
              ) : (
                <NotOkIcon size={20} />
              )}
            </Tooltip>
          </span>
        </div>
        <div className="col-xs-12 center-xs col-sm-9">
          <Button
            primary
            disabled={this.props.document && !this.props.document.fieldsAssigned}
            onClick={() => this.props.router.push(`/documents/${this.props.document._id}`)}
          >
            Siguiente
          </Button>
        </div>
      </div>
    )
  }

  renderNotification() {
    return (
      <div>
        <span className={styles.notification}>
          <Tooltip
            content={'Mantener presionado y arrastrar la firma, texto o checkbox al documento'}
          >
            <MdInfoOutline size={20} className="info-tooltip"/>
          </Tooltip>
        </span>
      </div>
    )
  }

  render() {

    return (
      <div className={styles.container}>
        <div className="section">
          <FixedHeader>
            <div className="header">
              <div className="row">
                <div className="col-xs-5 col-sm-6 col-md-">
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-4">
                      <Field type="signature" />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-4">
                      <Field type="text" />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-4">
                      {/* <Field type="checkbox" /> */}
                    </div>
                  </div>
                </div>
                <div className="col-xs-7 col-sm-6 col-md-">
                  <div className="row">
                    <div className="col-xs-12 center-xs col-sm-5 end-sm col-md-6">
                      {this.renderNotification()}
                    </div>
                    <div className="col-xs-12 end-xs col-sm-7 end-sm col-md-6 end-md">
                      {this.renderButtons()}
                    </div>
                  </div>
                </div>
              </div>
              { this.renderFirmasDisponibles() }
            </div>
          </FixedHeader>
          <div className={`pages ${styles.pages}`}>{this.renderPages()}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Prepare/index.js